import React from "react";
import Logo from "../assets/logo.png";
import { useParams } from "react-router-dom";
import { serverURL } from "../App";
const SuccessPage = () => {
  const { val } = useParams();
  console.log(val);
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>

      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      
        {val === "verifiedEmail"
          ? <p className="verifying_email">"Email verified successfully"  </p>
          : val === "updatedUser"
          ? <p className="verifying_email">Information <br/>updated successfully! <br/><br/>You can now login using the app with your user name and password.
          </p>: <p className="verifying_email">{val} </p>}
    

      <div className="play_store_container">
        <PlayStoreButton />
        <AppStoreButton />
      </div>
    </div>
  );
};

export default SuccessPage;
const PlayStoreButton = () => (
  <a
    href={serverURL + "playStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/playstore.png"
      alt="play store"
      style={{ width: "150px", marginRight: "25px" }}
    />
  </a>
);

const AppStoreButton = () => (
  <a
    href={serverURL + "appStoreLink"}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="https://api.synkoria.com/images/appstore.png"
      alt="app store"
      style={{ width: "150px" }}
    />
  </a>
);
